import { useTranslation } from 'react-i18next';

import { ConfirmActionModal } from '@/components/common';

interface DeactivatePriceListItemModalProps {
  opened: boolean;
  itemCode: string;
  onClose: () => void;
  onConfirm: () => void;
  loading?: boolean;
  isPaused?: boolean;
}

export const DeactivatePriceListItemModal = ({
  opened,
  itemCode,
  onClose,
  onConfirm,
  loading,
  isPaused
}: DeactivatePriceListItemModalProps) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionModal
      opened={opened}
      onClose={onClose}
      onConfirm={onConfirm}
      loading={loading}
      isPaused={isPaused}
      danger
      title={t('priceLists.deactivateItemTitle')}
      message={t('priceLists.deactivateItemMessage', { code: itemCode })}
      confirmLabel={t('priceLists.deactivateConfirm')}
    />
  );
};
